<template>
  <div>
    <div class="load-more-tickets">
      <a href="#" data-target="#crearTarimaModal" data-toggle="modal"
        ><span>Crear Tarima</span></a
      >
    </div>
    <div
      class="modal fade"
      id="crearTarimaModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none;"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Crear Tarima
            </h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <form @submit="crearTarimaSubmit">
            <div class="modal-body">
              <div class="form-group">
                <label
                  v-bind:class="{
                    'text-danger': current.errors && current.errors.tienda,
                  }"
                  >
                    Tienda Origen
                  </label>
                <select
                  class="form-control"
                  autofocus="autofocus"
                  v-model="current.tienda_origen"
                  :disabled="current.id != null"
                >
                  <option
                    v-for="(tienda, key) in tiendas"
                    :value="tienda.codigo"
                    :key="key"
                    >{{ tienda.nombre }}</option
                  >
                </select>
                <small
                  v-if="current.errors && current.errors.tienda_origen"
                  class="form-text text-danger"
                  >{{ current.errors.tienda_origen[0] }}</small
                >
              </div>
              <TiendaSelectComponent
                titulo="Tienda Destino"
                :current="current"
              />
              <small v-if="error_tarima" class="form-text text-danger">
                {{ error_tarima }}
              </small>
              <br>
              <button class="btn btn-block btn-primary" type="submit">
                Aceptar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    TiendaSelectComponent,
  },
  props: {
    id_tarima: {
      type: String,
    },
  },
  data() {
    return {
      current: {
        tienda_origen: '02',
        tienda: null,
        errors: {}
      },
      error_tarima: null,
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {

  },
  methods: {
    crearTarimaSubmit(e) {
      let self = this;
      e.preventDefault();
      console.log(self.current);
      DynamicService.save(
        "wms",
        "tarima",
        {
          tienda_origen: self.current.tienda_origen,
          tienda_destino: self.current.tienda,
        }
      )
        .then((res) => {
          $("#crearTarimaModal").modal("hide");
          self.$emit("refresh");
        })
        .catch((err) => {
          console.log(err.response.data)
          if (err.response.data.tarima) {
            self.error_tarima = err.response.data.tarima;
          }
        });
    },
  },
};
</script>
